import React from "react";

export default function Signature() {
  return (
    <div id="signature">
      <div>
        "<i>We make informed investing easier.</i>" - <b> Taj Morton</b>
      </div>
    </div>
  );
}
